import { render } from "./DiscountsDetail.vue?vue&type=template&id=4c8668b6&scoped=true&ts=true"
import script from "./DiscountsDetail.vue?vue&type=script&lang=ts"
export * from "./DiscountsDetail.vue?vue&type=script&lang=ts"

import "./DiscountsDetail.vue?vue&type=style&index=0&id=4c8668b6&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c8668b6"]])

export default __exports__